module.exports = __webpack_public_path__ + "img/diamonds.201e941e.png";